'use client';

import React from 'react';

import { CtaPanel } from '@components/CtaPanel/CtaPanel';
import { showLiveChat } from '@containers/LiveChat/LiveChat';
import { externalRoutes } from '@routes';

export const FeaturesCta: React.FC = () => (
  <CtaPanel
    buttons={[
      { href: externalRoutes.client.knowledgeBase, title: 'Browse full documentation' },
      {
        title: 'Ask on Chat',
        onClick: () => {
          showLiveChat();
        },
      },
    ]}
    title="Looking for more information?"
  />
);
